// extracted by mini-css-extract-plugin
export default {"getPaid":"getPaid_getPaid__s2bFn"};